import { FEE_PAYMENT_PREFIX } from '@exodus/ethereum-lib'
import lodash from 'lodash'

import getValueOfTransfers from './get-value-of-transfers.js'

// For ETH transactions, we store an array of token names inside
// the TX model. This array is used to display text in the UI for
// transactions which pay fees for ERC20 token transfers. This
// function is used to determine that array, choosing which
// tokens a transaction ostensibly 'paid fees' for.

export default function getNamesOfTokensTransferredByServerTx({
  asset,
  tokensByAddress,
  ourWalletAddress,
  serverTx,
}) {
  // Treat smart contract ETH transfer transactions as ETH transfers, not token transfers
  if (!getValueOfTransfers(ourWalletAddress, asset, serverTx.internal || []).isZero) {
    return []
  }

  const tokenAddresses = (serverTx.erc20 || []).map((event) => event.address)
  if (
    tokenAddresses.length === 0 &&
    serverTx.data &&
    serverTx.data !== '0x' &&
    !serverTx.data.startsWith(FEE_PAYMENT_PREFIX)
  ) {
    // We may still be transacting with tokens even though we found no `tokenAddresses`. This includes
    // failed token transactions as well as other transactions sent to a token contract. If we do not
    // recognize the `to` address in the next step, then we will not treat it as a token contract address.
    tokenAddresses.push(serverTx.to)
  }

  return lodash
    .uniq(tokenAddresses)
    .map((address) => tokensByAddress.get(address)?.name)
    .filter(Boolean)
}
